"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactCountdown = _interopRequireDefault(require("react-countdown"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _buttons = require("../../constants/buttons");
var TswBasic = function TswBasic(_ref) {
  var bgImage = _ref.bgImage,
    _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? true : _ref$overlay,
    title = _ref.title,
    subtitle = _ref.subtitle,
    topText = _ref.topText,
    whiteFont = _ref.whiteFont,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {
      text: ''
    } : _ref$cta,
    trailer = _ref.trailer,
    countdown = _ref.countdown,
    renderer = _ref.renderer,
    inView = _ref.inView;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hero--basic d8-u-bg-img d8-u-relative hero--tsw",
    role: "img",
    "aria-label": bgImage.alt || bgImage.title,
    style: {
      backgroundImage: "url(".concat(inView ? bgImage.url : '', ")")
    }
  }, overlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-overlay"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container max-width-lg flex items-center height-100% d8-u-relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "basic-content__wrapper text-component margin-auto@md"
  }, topText && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-ls-sm', 'd8-u-text-uppercase', whiteFont && 'd8-u-color-white')
  }, topText), title && /*#__PURE__*/_react["default"].createElement("h1", {
    className: (0, _classnames["default"])(whiteFont && 'd8-u-color-white', 'text-xxxl text-center')
  }, title), subtitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('subtitle', 'max-width-xxxs', 'text-md', 'margin-auto@sm', 'text-center@sm', whiteFont && 'd8-u-color-white', 'margin-top-md')
  }, subtitle), countdown && /*#__PURE__*/_react["default"].createElement(_reactCountdown["default"], {
    date: countdown,
    renderer: renderer
  }), trailer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-hero-trailer-btn text-center@sm"
  }, cta.text && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: cta.link,
    external: cta.external
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-top-md",
    text: cta.text,
    buttonType: _buttons.BUTTON_TYPES.WHITE,
    icon: cta.icon,
    buttonSize: _buttons.BUTTON_SIZES.LARGE,
    iconFlip: cta.iconFlip
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, cta.text && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center@sm"
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: cta.link,
    external: cta.external
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-top-md",
    text: cta.text,
    buttonType: _buttons.BUTTON_TYPES.WHITE,
    icon: cta.icon,
    iconFlip: cta.iconFlip
  })))))));
};
TswBasic.propTypes = {
  bgImage: _propTypes["default"].object,
  title: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  topText: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  overlay: _propTypes["default"].bool,
  inView: _propTypes["default"].bool,
  cta: _propTypes["default"].object,
  countdown: _propTypes["default"].string,
  renderer: _propTypes["default"].func,
  trailer: _propTypes["default"].bool
};
TswBasic.defaultProps = {
  overlay: true,
  cta: {
    text: ''
  },
  bgImage: {}
};
var _default = exports["default"] = TswBasic;